module.exports = __webpack_public_path__ + "static/media/EYInterstate-Light.52ee2dba.ttf";